
    const data = {"name":"src/core/icons/page-first","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41M6 6h2v12H6V6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            